(function() {
  var CoreDialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  CoreDialogController = App.loadClass('core::Angular/DialogController');

  exports.DialogController = (function(superClass) {
    extend(DialogController, superClass);

    function DialogController(scope, transitions, state, mups, modalInstance, window, transition$) {
      var options, ref;
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.mups = mups;
      this.modalInstance = modalInstance;
      this.window = window;
      this.transition$ = transition$;
      this.loadFormatHelp = bind(this.loadFormatHelp, this);
      this.setAlert = bind(this.setAlert, this);
      this.cancel = bind(this.cancel, this);
      this.finish = bind(this.finish, this);
      this.processUploads = bind(this.processUploads, this);
      this.process = bind(this.process, this);
      this.finishedUploading = bind(this.finishedUploading, this);
      this.inputFileUploading = bind(this.inputFileUploading, this);
      DialogController.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      options = JSON.parse(this.transition$.params().options);
      if ((ref = options.file_type) != null ? ref.extension : void 0) {
        this.mups.setFileExtension(options.file_type.extension);
      }
      this.scope.msg = {};
      this.scope.uploader = null;
      this.mups.options = options;
      this.scope.options = options;
      this.scope.$parent.title = 'Upload';
      this.scope.disable_upload = true;
      this.scope.ui = {};
      this.scope.ui.waiting_on_uploads = false;
      this.loadFormatHelp();
      this.mups.clearUpload();
      if (this.scope.options.type.name === 'Management Zone' || this.mups.getFileExtension() === null) {
        this.scope.file_ext = 'shp,shx,dbf,zip';
        this.scope.options.file_type = {
          id: null,
          extension: '.shp, .shx, .dbf'
        };
      } else {
        this.scope.file_ext = this.mups.getFileExtension();
      }
      this.scope.finish = this.finish;
      this.scope.finishedUploading = this.finishedUploading;
      this.scope.processUploads = this.processUploads;
      this.scope.process = this.process;
      this.window.inputFileUploading = this.inputFileUploading;
      this.scope.$watch('uploader', (function(_this) {
        return function() {
          var ref1;
          if ((ref1 = _this.scope.uploader) != null) {
            ref1.bind('FilesRemoved', function(uploader, file) {
              if (uploader.files.length === 0) {
                _this.scope.validFiles = false;
                _this.scope.disable_upload = true;
              }
              return _this.mups.deleteTempFile(file);
            });
          }
          return _this.mups.uploader = _this.scope.uploader;
        };
      })(this));
      this.scope.$on('uploads:clear_message', (function(_this) {
        return function() {
          return _this.scope.msg = {};
        };
      })(this));
      this.scope.$on('uploads:files_removed', (function(_this) {
        return function() {
          var ref1;
          if ((ref1 = _this.scope.uploader.files) != null ? ref1.length : void 0) {
            return _this.process();
          }
        };
      })(this));
    }

    DialogController.prototype.inputFileUploading = function() {
      this.scope.ui.waiting_on_uploads = true;
      return this.scope.$apply();
    };

    DialogController.prototype.finishedUploading = function() {
      this.scope.ui.waiting_on_uploads = false;
      return this.scope.disable_upload = false;
    };

    DialogController.prototype.process = function() {
      this.setAlert('info', 'Checking for duplicate files...');
      return this.mups.existingFiles().then((function(_this) {
        return function(response) {
          _this.scope.duplicates = response.data.data;
          if (_this.scope.duplicates.length) {
            _this.setAlert('warning', 'Found duplicate files. Delete or replace duplicate files before continuing.');
            return _this.mups.showDuplicateFileDialog(_this.scope.duplicates);
          } else {
            _this.processUploads();
            return _this.setAlert('info', 'Uploading files...');
          }
        };
      })(this));
    };

    DialogController.prototype.processUploads = function() {
      var params, ref, ref1;
      this.scope.disable_upload = true;
      params = {
        csq_id: (ref = this.mups.csq_id) != null ? ref : null,
        upload_type: this.scope.options.type.name,
        format_type: (ref1 = this.scope.options.format) != null ? ref1 : null,
        extension: this.scope.file_ext
      };
      return this.mups.processUploads(params).then((function(_this) {
        return function(response) {
          var ref2, ref3;
          if (response.data.status.type === 'success') {
            if ((ref2 = response.data.data.invalid_files) != null ? ref2.length : void 0) {
              _this.mups.queueRemoval(response.data.data.invalid_files);
              _this.mups.showInvalidShapefileDialog(response.data.data.invalid_files);
            }
            if ((ref3 = response.data.data.files) != null ? ref3.length : void 0) {
              _this.setAlert('success', 'Files uploaded successfully');
              _this.mups.csq_id = response.data.data.csq_id;
              _this.mups.file_list = response.data.data.files;
              _this.mups.validFiles = true;
            }
            return _this.finish();
          } else if (response.data.status.type === 'error') {
            _this.setAlert('error', response.data.status.msg);
            return _this.scope.disable_upload = false;
          }
        };
      })(this));
    };

    DialogController.prototype.finish = function() {
      this.modalInstance.close();
      return this.mups.finalizeUpload().then((function(_this) {
        return function(res) {
          return void 0;
        };
      })(this));
    };

    DialogController.prototype.cancel = function() {
      this.mups.deleteCsqDirectory();
      this.scope.uploader = null;
      return this.modalInstance.close();
    };

    DialogController.prototype.setAlert = function(type, text) {
      this.scope.msg.type = "alert-" + type;
      return this.scope.msg.text = text;
    };

    DialogController.prototype.loadFormatHelp = function() {
      var opts;
      opts = this.scope.options.file_type;
      if ((opts != null ? opts.name : void 0) == null) {
        this.scope.options.format = 'Shapefile';
        return this.scope.options.format_text = 'This is a multi-file format. You may upload the individual SHX, SHP, and DBF files that make up a set, or a zip containing one or more file sets.';
      } else {
        this.scope.options.format = this.mups.extractFormat(opts.name);
        return this.loadScopeData(this.mups.getFormatDescription(opts.id), 'text').then((function(_this) {
          return function(response) {
            return _this.scope.options.format_text = _this.scope.text;
          };
        })(this));
      }
    };

    return DialogController;

  })(CoreDialogController);

}).call(this);
